import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 清除样式
import "normalize.css";
// 公共样式
import "@/styles/common.less";
import { VueAxios } from "./utils/request";
import "./antDesign";
// 轮播图
import vueSwiper from "vue-awesome-swiper";
// 轮播图样式
import "@/static/css/swiper-bundle.css";
import "./permission";
import * as WPS from "./static/js/web-office-sdk-v1.1.16.es.js";

import * as Sentry from "@sentry/vue"

Vue.prototype.$wps = WPS;

Vue.use(vueSwiper);
Vue.use(VueAxios);
Vue.config.productionTip = false;

// 定义全局点击函数
Vue.prototype.globalClick = function(callback) {
  document.getElementById("#app").onclick = function() {
    callback();
  };
};


// 线上错误收集
Sentry.init({
  Vue,
  dsn: "http://50dc3a3e3a71c06ee99e09a4e5eec4f6@debug.test.luojigou.vip:8899/11",
  integrations: [
    new Sentry.BrowserTracing({
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      tracePropagationTargets: [],
    }),
    new Sentry.Replay(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, 
  // Session Replay  
  replaysSessionSampleRate: 0.1, 
  replaysOnErrorSampleRate: 1.0,
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
